// extracted by mini-css-extract-plugin
export var header = "_sb-1";
export var maskBottom = "_sb-6";
export var maskMiddle = "_sb-7";
export var maskTop = "_sb-5";
export var root = "_sb-0";
export var scrollDownButton = "_sb-3";
export var scrollDownButtonHidden = "_sb-4";
export var viewport = "_sb-2";